const images = {
    logo: require("./assets/images/icons/logo.png"),
    bg1: require("./assets/images/slide/bg-1.png"),
    bg2: require("./assets/images/slide/bg-2.png"),
    contact: require("./assets/images/contact.png"),
    whatWeDo: require("./assets/images/what-we-do.png"),
    about: require("./assets/images/about.png"),
    works: require("./assets/images/works.png"),
    blog: require("./assets/images/blog.png"),
    prolog: require("./assets/images/prolog.png"),
    waves: require("./assets/images/waves.png"),
    waves2: require("./assets/images/waves-2.png"),
    contactUs: require("./assets/images/contact-us.png"),
    gameOver: require("./assets/images/game-over.jpg"),
    contactIcon: require("./assets/images/icons/contact-icon.png"),
    whatWeDoIcon: require("./assets/images/icons/what-we-do-icon.png"),
    worksIcon: require("./assets/images/icons/works-icon.png"),
    line: require("./assets/images/icons/line.png"),
    aboutCover: require("./assets/images/about-cover.png"),

    // thumbnails
    bg1Thumbnail: require("./assets/images/bg-thumbnails/bg-1.jpg"),
    bg2Thumbnail: require("./assets/images/bg-thumbnails/bg-2.jpg"),
    
    aboutThumbnail: require("./assets/images/bg-thumbnails/about.jpg"),
    whatWeDoThumbnail: require("./assets/images/bg-thumbnails/what-we-do.jpg"),
    contactThumbnail: require("./assets/images/bg-thumbnails/contact.jpg"),
    worksThumbnail: require("./assets/images/bg-thumbnails/works.jpg"),
    blogThumbnail: require("./assets/images/bg-thumbnails/blog.jpg"),
    gameOverThumbnail: require("./assets/images/bg-thumbnails/game-over.jpg"),
    // 

    // about
    img1: require("./assets/images/about/img-1.png"),
    img2: require("./assets/images/about/img-2.png"),
    img3: require("./assets/images/about/img-3.png"),
    img4: require("./assets/images/about/img-4.png"),
    //

    // sponsors
    kobo: require("./assets/images/icons/sponsors/kobo.png"),
    seed: require("./assets/images/icons/sponsors/seed.png"),
    prive: require("./assets/images/icons/sponsors/prive.png"),
    lh: require("./assets/images/icons/sponsors/lh.png"),
    farms: require("./assets/images/icons/sponsors/farms.png"),
    mvx: require("./assets/images/icons/sponsors/mvx.png"),
    //

    // works
    work1: require("./assets/images/works/work-1.png"),
    work2: require("./assets/images/works/work-2.png"),
    work3: require("./assets/images/works/work-3.png"),
    work4: require("./assets/images/works/work-4.png"),
    work5: require("./assets/images/works/work-5.png"),

    workPage1: require("./assets/images/works/works-page/work-1.png"),
    workPage2: require("./assets/images/works/works-page/work-2.png"),
    workPage3: require("./assets/images/works/works-page/work-3.png"),
    workPage4: require("./assets/images/works/works-page/work-4.png"),
    workPage5: require("./assets/images/works/works-page/work-5.png"),
    //

    // blog
    blogPage1: require("./assets/images/blog/blog-page/blog-1.png"),
    blogPage2: require("./assets/images/blog/blog-page/blog-2.png"),
    blogPage3: require("./assets/images/blog/blog-page/blog-3.png"),
    blogPage4: require("./assets/images/blog/blog-page/blog-4.png"),
    blogPage5: require("./assets/images/blog/blog-page/blog-5.png"),
    blogPage6: require("./assets/images/blog/blog-page/blog-6.png"),
    //

    // socials
    facebook: require("./assets/images/icons/socials/facebook.png"),
    instagram: require("./assets/images/icons/socials/instagram.png"),
    twitter: require("./assets/images/icons/socials/twitter.png"),
    //
};

const localData = {
    images,
    svgs: {
        togglerIcon: (
            <svg width="58" height="40" viewBox="0 0 58 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.68982 3.53668H54.5188M3.68982 19.828H54.5188M3.68982 36.1194H54.5188"
                    stroke="white"
                    strokeWidth="6.51654"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        close: (
            <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3L49 49" stroke="white" strokeWidth="5" strokeLinecap="round" />
                <path d="M49 3L3 49" stroke="white" strokeWidth="5" strokeLinecap="round" />
            </svg>
        ),
        wave: (
            <svg
                className="waves"
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
                shapeRendering="auto"
            >
                <defs>
                    <path
                        id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                    />
                </defs>
                <g className="parallax">
                    <use href="#gentle-wave" x="48" y="0" fill="rgba(255, 0, 0, 0.5)" />
                    <use href="#gentle-wave" x="48" y="3" fill="rgba(79, 3, 139, 0.6)" />
                    <use href="#gentle-wave" x="48" y="5" fill="rgba(150,33,114,0.3)" />
                    <use href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,1)" />
                </g>
            </svg>
        ),
        waveSingle: (
            <svg
                className="waves"
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
                shapeRendering="auto"
            >
                <defs>
                    <path
                        id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                    />
                </defs>
                <g className="parallax">
                    <use href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,1)" />
                </g>
            </svg>
        ),
        marketing: (
            <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M55.407 41.5144H53.2016V28.8321H32.7646V19.4858H34.6136C37.696 19.4858 40.2066 16.979 40.2066 13.8947V5.59295C40.2047 2.50859 37.6941 0 34.6118 0H26.3882C23.3059 0 20.7953 2.50859 20.7953 5.59295V13.8947C20.7953 16.977 23.3039 19.4858 26.3882 19.4858H28.9522V28.8321H7.79841V41.5144H5.59295C2.50859 41.5144 0 44.023 0 47.1053V55.407C0 58.4914 2.50859 61 5.59295 61H13.8165C16.8989 61 19.4095 58.4914 19.4095 55.407V47.1053C19.4095 44.023 16.9009 41.5144 13.8165 41.5144H11.6109V32.6446H28.9521V41.5144H26.3881C23.3057 41.5144 20.7951 44.0211 20.7951 47.1053V55.407C20.7951 58.4894 23.3037 61 26.3881 61H34.6117C37.694 61 40.2046 58.4914 40.2046 55.407V47.1053C40.2046 44.023 37.696 41.5144 34.6117 41.5144H32.7626V32.6446H49.389V41.5144H47.1835C44.1011 41.5144 41.5905 44.0211 41.5905 47.1053V55.407C41.5905 58.4894 44.0991 61 47.1835 61H55.407C58.4914 61 61 58.4914 61 55.407V47.1053C61 44.023 58.4914 41.5144 55.407 41.5144ZM24.6078 13.8947V5.59295C24.6078 4.61123 25.4065 3.8125 26.3882 3.8125H34.6118C35.5935 3.8125 36.3922 4.61123 36.3922 5.59295V13.8947C36.3922 14.8764 35.5935 15.6733 34.6118 15.6733H26.3882C25.4065 15.6731 24.6078 14.8764 24.6078 13.8947ZM15.597 47.1053V55.407C15.597 56.3888 14.7982 57.1875 13.8165 57.1875H5.59295C4.61123 57.1875 3.8125 56.3888 3.8125 55.407V47.1053C3.8125 46.1236 4.61123 45.3269 5.59295 45.3269H13.8165C14.7982 45.3269 15.597 46.1236 15.597 47.1053ZM36.3922 47.1053V55.407C36.3922 56.3888 35.5935 57.1875 34.6118 57.1875H26.3882C25.4065 57.1875 24.6078 56.3888 24.6078 55.407V47.1053C24.6078 46.1236 25.4065 45.3269 26.3882 45.3269H34.6118C35.5935 45.3269 36.3922 46.1236 36.3922 47.1053ZM57.1875 55.407C57.1875 56.3888 56.3888 57.1875 55.407 57.1875H47.1835C46.2018 57.1875 45.403 56.3888 45.403 55.407V47.1053C45.403 46.1236 46.2018 45.3269 47.1835 45.3269H55.407C56.3888 45.3269 57.1875 46.1236 57.1875 47.1053V55.407Z"
                    fill="url(#paint0_linear_32_107)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_32_107"
                        x1="54"
                        y1="-5"
                        x2="3.11459e-08"
                        y2="57.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF0000" />
                        <stop offset="1" stopColor="#8800C7" />
                    </linearGradient>
                </defs>
            </svg>
        ),
        architecture: (
            <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M48.6525 8.34761C43.2696 2.96445 36.1125 0 28.5 0C20.8875 0 13.7304 2.96445 8.34749 8.34761C2.96445 13.7304 0 20.8875 0 28.5C0 36.1125 2.96445 43.2696 8.34749 48.6525C13.7304 54.0356 20.8875 57 28.5 57C36.1125 57 43.2696 54.0356 48.6525 48.6524C54.0356 43.2696 57 36.1125 57 28.5C57 20.8875 54.0356 13.7304 48.6525 8.34761ZM28.5 55.2C13.7775 55.2 1.79995 43.2225 1.79995 28.5C1.79995 13.7775 13.7775 1.79995 28.5 1.79995C43.2225 1.79995 55.2 13.7775 55.2 28.5C55.2 43.2225 43.2225 55.2 28.5 55.2Z"
                    fill="url(#paint0_linear_32_139)"
                />
                <path
                    d="M47.0963 25.3371L44.4483 14.7447C44.1307 13.4746 43.1444 12.4882 41.8742 12.1707L31.2819 9.52267C30.0833 9.22331 28.7959 9.57967 27.9223 10.4533L8.83432 29.5416C8.18639 30.1895 7.78015 31.0523 7.74809 31.968C7.71335 32.9602 8.08385 33.8987 8.78199 34.597L22.0224 47.8374C22.712 48.527 23.6179 48.8717 24.5239 48.8717C25.4298 48.8717 26.3358 48.5269 27.0254 47.8374L31.8365 43.0263C32.1845 42.6783 32.1845 42.1142 31.8365 41.7662L31.8238 41.7535C31.4758 41.4055 30.9117 41.4055 30.5637 41.7535L25.7526 46.5645C25.075 47.2421 23.9727 47.2421 23.2952 46.5645L10.0548 33.324C9.72661 32.9959 9.54593 32.5595 9.54593 32.0954C9.54593 31.6313 9.72661 31.1948 10.0548 30.8667L29.1953 11.7261C29.524 11.3974 29.9719 11.2178 30.4281 11.2178C30.5676 11.2178 30.7078 11.2346 30.8456 11.269L41.4379 13.917C42.0618 14.073 42.5461 14.5575 42.7023 15.1814L45.3503 25.7736C45.4976 26.3624 45.3224 26.9948 44.8932 27.4238L33.6507 38.6661C33.3027 39.0142 33.3027 39.5783 33.6507 39.9263C33.6549 39.9305 33.6593 39.9348 33.6634 39.939C34.0114 40.287 34.5755 40.287 34.9235 39.939L46.1658 28.6966C47.0395 27.8231 47.3961 26.5358 47.0963 25.3371Z"
                    fill="url(#paint1_linear_32_139)"
                />
                <path
                    d="M35.8509 28.5726L34.9535 28.1399L35.8509 27.7073C36.2987 27.4914 36.4866 26.9534 36.2708 26.5057L34.5272 22.8896C34.3113 22.442 33.7734 22.2541 33.3256 22.4699L31.1674 23.5107V21.1147C31.1674 20.6175 30.7644 20.2147 30.2674 20.2147H26.2529C25.7558 20.2147 25.3529 20.6175 25.3529 21.1147V23.5107L23.1947 22.4699C22.7471 22.2541 22.209 22.442 21.9932 22.8896L20.2496 26.5057C20.0337 26.9534 20.2216 27.4914 20.6695 27.7073L21.5669 28.1399L20.6695 28.5726C20.2217 28.7885 20.0338 29.3264 20.2496 29.7742L21.9932 33.3903C22.2091 33.8379 22.7471 34.0261 23.1947 33.81L25.3529 32.7692V35.1652C25.3529 35.6624 25.7559 36.0652 26.2529 36.0652H30.2674C30.7645 36.0652 31.1674 35.6623 31.1674 35.1652V32.7692L33.3256 33.81C33.773 34.0255 34.3112 33.8378 34.5272 33.3903L36.2708 29.7742C36.4865 29.3265 36.2986 28.7885 35.8509 28.5726ZM32.4905 28.9508L34.2584 29.8032L33.2966 31.798L30.6582 30.5256C30.3794 30.3911 30.0509 30.4095 29.7887 30.574C29.5265 30.7387 29.3674 31.0266 29.3674 31.3363V34.2653H27.1529V31.3363C27.1529 31.0267 26.9938 30.7388 26.7316 30.574C26.4693 30.4094 26.1409 30.3909 25.8622 30.5256L23.2237 31.798L22.2619 29.8032L24.0298 28.9508C24.3411 28.8007 24.539 28.4856 24.539 28.1401C24.539 27.7945 24.3412 27.4794 24.0298 27.3294L22.2619 26.4769L23.2237 24.4822L25.8622 25.7545C26.1409 25.889 26.4695 25.8706 26.7316 25.7061C26.9938 25.5416 27.1529 25.2535 27.1529 24.9438V22.0148H29.3673V24.9438C29.3673 25.2534 29.5264 25.5413 29.7886 25.7061C30.0508 25.8709 30.3792 25.889 30.6581 25.7545L33.2965 24.4822L34.2583 26.4769L32.4904 27.3294C32.1791 27.4794 31.9812 27.7945 31.9812 28.1401C31.9814 28.4856 32.1792 28.8006 32.4905 28.9508Z"
                    fill="url(#paint2_linear_32_139)"
                />
                <path
                    d="M40.4337 16.1854C39.1471 14.8989 37.0535 14.8987 35.7669 16.1854C35.1435 16.8087 34.8004 17.6375 34.8004 18.5189C34.8004 19.4002 35.1436 20.2291 35.7669 20.8524C36.4102 21.4957 37.2552 21.8173 38.1004 21.8173C38.9455 21.8173 39.7905 21.4956 40.4338 20.8524V20.8523C41.0571 20.2292 41.4003 19.4002 41.4003 18.5189C41.4003 17.6375 41.0571 16.8087 40.4337 16.1854ZM39.1609 19.5796C38.5759 20.1645 37.6244 20.1645 37.0396 19.5797C36.7562 19.2964 36.6003 18.9195 36.6003 18.5189C36.6003 18.1182 36.7562 17.7415 37.0396 17.4583C37.332 17.1658 37.7161 17.0196 38.1002 17.0196C38.4843 17.0196 38.8685 17.1659 39.1609 17.4583C39.4442 17.7416 39.6002 18.1182 39.6002 18.5189C39.6002 18.9195 39.4442 19.2964 39.1609 19.5796Z"
                    fill="url(#paint3_linear_32_139)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_32_139"
                        x1="28.5"
                        y1="0"
                        x2="28.5"
                        y2="57"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF0000" />
                        <stop offset="1" stopColor="#8800C7" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_32_139"
                        x1="27.4733"
                        y1="9.41846"
                        x2="27.4733"
                        y2="48.8717"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF0000" />
                        <stop offset="1" stopColor="#8800C7" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_32_139"
                        x1="28.2602"
                        y1="20.2147"
                        x2="28.2602"
                        y2="36.0652"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF0000" />
                        <stop offset="1" stopColor="#8800C7" />
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_32_139"
                        x1="38.1003"
                        y1="15.2205"
                        x2="38.1003"
                        y2="21.8173"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FF0000" />
                        <stop offset="1" stopColor="#8800C7" />
                    </linearGradient>
                </defs>
            </svg>
        ),
        planning: (
            <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.2125 5.25549H18.4875V8.88049H19.2125V5.25549Z" fill="url(#paint0_linear_32_183)" />
                <path d="M29.3625 5.25549H28.6375V8.88049H29.3625V5.25549Z" fill="url(#paint1_linear_32_183)" />
                <path
                    d="M52.5625 5.25549H49.1179V8.88049H52.5625C53.6508 8.88049 54.3742 9.60549 54.3742 10.6922V50.5664C54.3742 51.6555 53.6492 52.3789 52.5625 52.3789H5.4375C4.35 52.3789 3.625 51.6539 3.625 50.5664V10.693C3.625 9.60468 4.35 8.8813 5.4375 8.8813H9.06169V5.2563H5.4375C2.35544 5.25549 0 7.61174 0 10.6938V50.568C0 53.6501 2.35544 56.0063 5.4375 56.0063H52.5625C55.6437 56.0063 58 53.6501 58 50.568V10.6938C58 7.7938 55.4625 5.25549 52.5625 5.25549Z"
                    fill="url(#paint2_linear_32_183)"
                />
                <path d="M39.3313 5.25549H38.7876V8.88049H39.3313V5.25549Z" fill="url(#paint3_linear_32_183)" />
                <path
                    d="M44.225 12.3258C45.857 12.3258 47.125 11.0571 47.125 9.42583V4.89377C47.125 3.26172 45.857 1.99377 44.225 1.99377C42.5937 1.99377 41.325 3.26172 41.325 4.89377V9.42583C41.325 10.8758 42.5945 12.3258 44.225 12.3258Z"
                    fill="url(#paint4_linear_32_183)"
                />
                <path
                    d="M34.0741 12.3258C35.7069 12.3258 36.9741 11.0571 36.9741 9.42583V4.89377C36.9741 3.26172 35.7069 1.99377 34.0741 1.99377C32.4428 1.99377 31.1741 3.26172 31.1741 4.89377V9.42583C31.1741 10.8758 32.4436 12.3258 34.0741 12.3258Z"
                    fill="url(#paint5_linear_32_183)"
                />
                <path
                    d="M23.9249 12.3258C25.557 12.3258 26.8249 11.0571 26.8249 9.42583V4.89377C26.8249 3.26172 25.557 1.99377 23.9249 1.99377C22.2937 1.99377 21.0249 3.26172 21.0249 4.89377V9.42583C21.0249 10.8758 22.2937 12.3258 23.9249 12.3258Z"
                    fill="url(#paint6_linear_32_183)"
                />
                <path
                    d="M13.775 12.3258C15.4071 12.3258 16.675 11.0571 16.675 9.42583V4.89377C16.675 3.26172 15.4071 1.99377 13.775 1.99377C12.1438 1.99377 10.875 3.26172 10.875 4.89377V9.42583C10.875 10.8758 12.1438 12.3258 13.775 12.3258Z"
                    fill="url(#paint7_linear_32_183)"
                />
                <path
                    d="M28.4563 46.582C36.9726 46.582 43.8625 39.6929 43.8625 31.175C43.8625 22.657 36.9726 15.7695 28.4563 15.7695C19.9375 15.7695 13.05 22.657 13.05 31.175C13.05 39.6929 19.9375 46.582 28.4563 46.582ZM17.4 25.1937L18.4875 25.7375L18.85 25.1937L17.7617 24.65C18.85 23.0179 20.118 21.5679 21.9305 20.482L22.4742 21.5695L23.018 21.207L22.4742 20.1195C24.1063 19.2133 26.0992 18.6695 28.093 18.4875V19.7554H28.818V18.4875C30.8125 18.4875 32.8063 19.032 34.4359 20.1195L33.8922 21.207L34.4359 21.5695L34.9797 20.482C36.6125 21.5695 38.0625 23.0195 39.1476 24.65L38.0609 25.1937L38.4226 25.7375L39.5109 25.1937C40.4164 26.8258 40.9609 28.8179 41.143 30.8117H39.8742V31.5367H41.143C41.143 33.5296 40.5992 35.5242 39.5117 37.1546L38.4226 36.61L38.0625 37.1562L39.15 37.7C38.0625 39.332 36.6125 40.7812 34.9821 41.8671L34.4384 40.7804L33.8946 41.1437L34.4384 42.2312C32.8063 43.1367 30.8142 43.6804 28.8204 43.8625V42.5937H28.0938V43.8617C26.1 43.8617 24.1063 43.3179 22.475 42.2296L23.0188 41.1421L22.475 40.7804L21.9313 41.8687C20.3 40.7804 18.85 39.3312 17.7625 37.7016L18.8509 37.1578L18.4884 36.6133L17.4009 37.1578C16.4946 35.5242 15.9509 33.5336 15.7688 31.5391H17.0375V30.8141H15.7688C15.95 28.8187 16.4938 26.8258 17.4 25.1937Z"
                    fill="url(#paint8_linear_32_183)"
                />
                <path
                    d="M28.4563 21.5687V31.175H38.0626C38.0626 25.9187 33.7125 21.5687 28.4563 21.5687Z"
                    fill="url(#paint9_linear_32_183)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_32_183"
                        x1="18.85"
                        y1="5.25549"
                        x2="18.85"
                        y2="8.88049"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_32_183"
                        x1="29"
                        y1="5.25549"
                        x2="29"
                        y2="8.88049"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_32_183"
                        x1="29"
                        y1="5.25549"
                        x2="29"
                        y2="56.0063"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_32_183"
                        x1="39.0595"
                        y1="5.25549"
                        x2="39.0595"
                        y2="8.88049"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint4_linear_32_183"
                        x1="44.225"
                        y1="1.99377"
                        x2="44.225"
                        y2="12.3258"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint5_linear_32_183"
                        x1="34.0741"
                        y1="1.99377"
                        x2="34.0741"
                        y2="12.3258"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint6_linear_32_183"
                        x1="23.9249"
                        y1="1.99377"
                        x2="23.9249"
                        y2="12.3258"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint7_linear_32_183"
                        x1="13.775"
                        y1="1.99377"
                        x2="13.775"
                        y2="12.3258"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint8_linear_32_183"
                        x1="28.4563"
                        y1="15.7695"
                        x2="28.4563"
                        y2="46.582"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint9_linear_32_183"
                        x1="33.2594"
                        y1="21.5687"
                        x2="33.2594"
                        y2="31.175"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                </defs>
            </svg>
        ),
        development: (
            <svg width="60" height="56" viewBox="0 0 60 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M40.4202 48.3464C40.1093 48.1572 39.8384 47.9036 39.6231 47.5963C39.5236 47.4545 39.4396 47.3046 39.37 47.1498H4.04095V12.3275H51.9951V35.0652C53.0188 35.1576 53.8778 35.83 54.2385 36.7508C54.5578 36.5757 54.9137 36.4676 55.2878 36.4346C55.5408 36.4126 55.7922 36.4283 56.0359 36.4764V3.65247C56.0359 1.79559 54.5255 0.284912 52.6688 0.284912H3.36741C1.51068 0.284912 0 1.79559 0 3.65247V47.8234C0 49.6803 1.51068 51.1908 3.36741 51.1908H40.1133C39.8265 50.6102 39.7585 49.9546 39.9273 49.324C40.0246 48.9612 40.1929 48.6303 40.4202 48.3464ZM48.2972 5.9397C48.2972 5.25301 48.8539 4.69621 49.5406 4.69621H50.7839C51.4707 4.69621 52.0273 5.25287 52.0273 5.9397V7.34893C52.0273 8.03561 51.4706 8.59228 50.7839 8.59228H49.5406C48.8537 8.59228 48.2972 8.03561 48.2972 7.34893V5.9397ZM42.5156 5.9397C42.5156 5.25301 43.0722 4.69621 43.7589 4.69621H45.0024C45.6892 4.69621 46.2457 5.25287 46.2457 5.9397V7.34893C46.2457 8.03561 45.6891 8.59228 45.0024 8.59228H43.7589C43.0722 8.59228 42.5156 8.03561 42.5156 7.34893V5.9397ZM36.7337 5.9397C36.7337 5.25301 37.2906 4.69621 37.9771 4.69621H39.2204C39.9073 4.69621 40.4639 5.25287 40.4639 5.9397V7.34893C40.4639 8.03561 39.9073 8.59228 39.2204 8.59228H37.9771C37.2906 8.59228 36.7337 8.03561 36.7337 7.34893V5.9397Z"
                    fill="url(#paint0_linear_32_225)"
                />
                <path
                    d="M59.992 45.975L59.6184 43.856C59.5679 43.5707 59.296 43.3801 59.0104 43.4304L57.1261 43.7625C56.8999 43.2317 56.611 42.7344 56.2681 42.2794L57.4989 40.8123C57.5883 40.7059 57.6319 40.5681 57.6199 40.4293C57.6076 40.2906 57.5407 40.1626 57.4341 40.073L55.7861 38.6899C55.6796 38.6005 55.5414 38.557 55.4028 38.5692C55.2641 38.5813 55.136 38.648 55.0466 38.7546L53.817 40.2206C53.3122 39.9634 52.7722 39.7651 52.2066 39.6342V37.7207C52.2066 37.431 51.9715 37.1958 51.6818 37.1958H49.53C49.2404 37.1958 49.0052 37.431 49.0052 37.7207V39.6342C48.4392 39.7649 47.8999 39.9634 47.3948 40.2206L46.1649 38.7548C45.9785 38.5327 45.6476 38.5039 45.4254 38.69L43.7773 40.073C43.6707 40.1626 43.604 40.2906 43.5917 40.4293C43.5797 40.5681 43.6231 40.7061 43.7126 40.8127L44.9435 42.2795C44.6012 42.7344 44.3117 43.2319 44.0855 43.7626L42.2012 43.4304C41.9163 43.3802 41.6438 43.5707 41.5932 43.856L41.2198 45.975C41.1956 46.112 41.2269 46.2529 41.3065 46.367C41.3866 46.4812 41.5079 46.5588 41.6451 46.5829L43.5308 46.9153C43.5616 47.4995 43.6633 48.0647 43.827 48.603L42.1696 49.5595C42.049 49.6288 41.9612 49.7437 41.925 49.878C41.889 50.0125 41.908 50.1556 41.9775 50.2762L43.0532 52.1395C43.1225 52.2601 43.2374 52.348 43.3717 52.384C43.4164 52.396 43.462 52.4019 43.5076 52.4019C43.5989 52.4019 43.6893 52.3782 43.7699 52.3316L45.4286 51.3738C45.8187 51.7918 46.259 52.1621 46.7402 52.4753L46.0853 54.2746C46.0378 54.4055 46.044 54.5498 46.1028 54.676C46.1617 54.8021 46.2682 54.8997 46.3989 54.9471L48.4204 55.6828C48.4784 55.704 48.5392 55.7148 48.6 55.7148C48.6757 55.7148 48.7519 55.6984 48.822 55.6656C48.9482 55.6068 49.0455 55.5002 49.0931 55.3694L49.7479 53.5701C50.0286 53.6041 50.3144 53.6216 50.6043 53.6216C50.8942 53.6216 51.18 53.6038 51.4607 53.5701L52.1157 55.3694C52.1631 55.5002 52.2609 55.6068 52.3867 55.6656C52.4567 55.6983 52.5326 55.7148 52.6088 55.7148C52.6693 55.7148 52.7302 55.7043 52.7882 55.6828L54.81 54.9471C54.9404 54.8997 55.047 54.8018 55.1058 54.676C55.1646 54.5498 55.1709 54.4055 55.1233 54.2746L54.4684 52.4756C54.9492 52.1624 55.3895 51.7918 55.78 51.3741L57.4387 52.3319C57.5191 52.3782 57.6097 52.4022 57.701 52.4022C57.7465 52.4022 57.7925 52.396 57.8369 52.3843C57.9714 52.3483 58.086 52.2601 58.1554 52.1398L59.2311 50.2762C59.3006 50.1559 59.3196 50.0125 59.2836 49.878C59.2474 49.744 59.1596 49.6291 59.039 49.5595L57.3818 48.6032C57.5456 48.0649 57.647 47.4996 57.6777 46.9155L59.5635 46.5831C59.7007 46.5589 59.8224 46.4813 59.9021 46.3672C59.9848 46.2529 60.0161 46.112 59.992 45.975ZM50.606 49.3421C49.0122 49.3421 47.7198 48.0497 47.7198 46.4558C47.7198 44.8618 49.0123 43.5696 50.606 43.5696C52.2 43.5696 53.4923 44.8618 53.4923 46.4558C53.4923 48.0497 52.2 49.3421 50.606 49.3421Z"
                    fill="url(#paint1_linear_32_225)"
                />
                <path
                    d="M23.5317 31.6302C23.5317 30.9512 23.1338 30.3275 22.5179 30.0415L16.8805 27.4222L22.518 24.8026C23.1338 24.5163 23.5317 23.8928 23.5317 23.2141V23.1685C23.5317 22.567 23.229 22.0147 22.7223 21.692C22.442 21.5129 22.1155 21.4182 21.7785 21.4182C21.5244 21.4182 21.2694 21.4741 21.0412 21.5801L12.0286 25.7712C11.4129 26.0575 11.0153 26.6811 11.0153 27.3596V27.4849C11.0153 28.1626 11.4128 28.7857 12.0287 29.0735L21.0422 33.265C21.2752 33.3729 21.5234 33.4276 21.7797 33.4276C22.1138 33.4276 22.4393 33.3327 22.7223 33.1527C23.2293 32.8287 23.5319 32.2769 23.5319 31.676L23.5317 31.6302Z"
                    fill="url(#paint2_linear_32_225)"
                />
                <path
                    d="M32.4243 17.1476C32.0955 16.6976 31.5667 16.429 31.0096 16.429H30.9647C30.1997 16.429 29.5291 16.9183 29.296 17.6457L23.3579 36.0447C23.1889 36.576 23.284 37.1611 23.6124 37.611C23.9411 38.0608 24.47 38.3296 25.027 38.3296H25.0721C25.8367 38.3296 26.507 37.84 26.7398 37.1128L32.6772 18.7152C32.8478 18.1844 32.7532 17.5984 32.4243 17.1476Z"
                    fill="url(#paint3_linear_32_225)"
                />
                <path
                    d="M44.0074 25.7711L34.9946 21.5799C34.7672 21.4742 34.5126 21.4183 34.2585 21.4183C33.9216 21.4183 33.595 21.5128 33.3148 21.6915C32.8073 22.0149 32.5045 22.567 32.5045 23.1685V23.2141C32.5045 23.8922 32.9022 24.5158 33.5185 24.8033L39.1558 27.4223L33.5184 30.0415C32.9024 30.3275 32.5045 30.9512 32.5045 31.6302V31.676C32.5045 32.2768 32.8073 32.8285 33.3145 33.1528C33.5966 33.3326 33.9223 33.4276 34.2568 33.4276C34.5128 33.4276 34.7607 33.3729 34.9954 33.2646L44.0085 29.073C44.6239 28.786 45.0213 28.1627 45.0213 27.485V27.3597C45.0209 26.6811 44.6232 26.0575 44.0074 25.7711Z"
                    fill="url(#paint4_linear_32_225)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_32_225"
                        x1="28.018"
                        y1="0.284912"
                        x2="28.018"
                        y2="51.1908"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_32_225"
                        x1="50.6059"
                        y1="37.1958"
                        x2="50.6059"
                        y2="55.7148"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_32_225"
                        x1="17.2736"
                        y1="21.4182"
                        x2="17.2736"
                        y2="33.4276"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_32_225"
                        x1="28.0181"
                        y1="16.429"
                        x2="28.0181"
                        y2="38.3296"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                    <linearGradient
                        id="paint4_linear_32_225"
                        x1="38.7629"
                        y1="21.4183"
                        x2="38.7629"
                        y2="33.4276"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                </defs>
            </svg>
        ),
        subscribe: (
            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M55.75 0.5C61.1348 0.5 65.5 4.86522 65.5 10.25V55.75C65.5 61.1348 61.1348 65.5 55.75 65.5H10.25C4.86522 65.5 0.5 61.1348 0.5 55.75V10.25C0.5 4.86522 4.86522 0.5 10.25 0.5H55.75ZM7 55.75C7 57.5449 8.45507 59 10.25 59H55.75C57.5449 59 59 57.5449 59 55.75V39.5H48.9249C47.4664 46.6855 41.2665 52.1493 33.7331 52.4838L33 52.5C25.3841 52.5 18.9918 47.2607 17.2309 40.1899L17.0751 39.5H7V55.75ZM55.75 7H10.25C8.45507 7 7 8.45507 7 10.25V33H20C21.6667 33 23.0404 34.2546 23.2281 35.871L23.25 36.25C23.25 41.6348 27.6152 46 33 46C38.1925 46 42.4369 41.941 42.7334 36.8229L42.7719 35.871C42.9452 34.379 44.129 33.1952 45.621 33.0219L46 33H59V10.25C59 8.45507 57.5449 7 55.75 7Z"
                    fill="url(#paint0_linear_341_10)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_341_10"
                        x1="79.5"
                        y1="-7"
                        x2="-37"
                        y2="93.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8800C7" />
                        <stop offset="1" stopColor="#FF0000" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },

    error: {
        "not-found": {
            message: "nothing exist here",
            cover: images.gameOver,
            status: 404,
        },
        "connection-error": {
            message: "connection error",
            cover: images.gameOver,
            status: 400,
        },
    },
};

export default localData;
